module.exports = __webpack_public_path__ + "img/banner05_info_S_2.d77f71f0.png";